import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IDegreeDurationPayload, IInitialStateDegreeDuration } from "../types";
import { GetDegreeDuration, GetDeleteDegreeDuration } from "./thunk";

const initialState: IInitialStateDegreeDuration = {
    degreeDuration: [],
    degreeDurationRestore: [],
    isLoadingDegreeDuration: false,
    isViewDegreeDurationRestore: false,
};

const degreeDurationSlice = createSlice({
    initialState,
    name: "degreeDuration",
    reducers: {
        setDegreeDuration: (state, action: PayloadAction<IDegreeDurationPayload[]>) => {
            state.degreeDuration = action.payload;
        },
        deletedDegreeDuration: (state, action: PayloadAction<number>) => {
            state.degreeDuration = state.degreeDuration.filter(elem => elem.id !== action.payload);
        },

        updateDegreeDuration: (state, action: PayloadAction<IDegreeDurationPayload>) => {
            state.degreeDuration = state.degreeDuration.map(elem =>
                elem.id === action.payload.id ? { ...elem, ...action.payload } : elem
            );
        },
        setRestoreDegreeDuration: (state, action) => {
            state.degreeDurationRestore = action.payload;
        },
        deletedRestoreDegreeDuration: (state, action) => {
            state.degreeDurationRestore = state.degreeDurationRestore.filter(elem => elem.id !== action.payload);
        },
        setIsViewRestoreDegreeDuration: state => {
            state.isViewDegreeDurationRestore = !state.isViewDegreeDurationRestore;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(GetDegreeDuration.pending, state => {
                state.isLoadingDegreeDuration = true;
            })
            .addCase(GetDegreeDuration.fulfilled, state => {
                state.isLoadingDegreeDuration = false;
            })
            .addCase(GetDegreeDuration.rejected, state => {
                state.isLoadingDegreeDuration = false;
            })
            .addCase(GetDeleteDegreeDuration.pending, state => {
                state.isLoadingDegreeDuration = true;
            })
            .addCase(GetDeleteDegreeDuration.fulfilled, state => {
                state.isLoadingDegreeDuration = false;
            })
            .addCase(GetDeleteDegreeDuration.rejected, state => {
                state.isLoadingDegreeDuration = false;
            });
    },
});

export const {
    setDegreeDuration,
    deletedDegreeDuration,
    updateDegreeDuration,
    setRestoreDegreeDuration,
    deletedRestoreDegreeDuration,
    setIsViewRestoreDegreeDuration,
} = degreeDurationSlice.actions;

export default degreeDurationSlice;
